module.exports = __webpack_public_path__ + "img/avatar.5078a053.png";